import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { getErrorMessage } from "../../../utils/utils";
import { IProjectPlanned, IProjectPlannedResponse, ProjectBudgetPosition } from "../../../@types/project/project-planned.type";
import { IProjectPlannedHistoryPage } from "../../../@types/project/project-implemented.type";

export const addOrUpdateProjectPlanned = async (planned: IProjectPlanned) => {
  try {
    const { data } = await Api.post('/api/ProjectPlanned/AddOrUpdateProjectPlanned', planned);
    return data;

  } catch (error) {
    const message = 'Erro ao criar ou atualizar Projeto Planejado';
    throw new ApiException(getErrorMessage(error, message));
  }
}

export const addAllocationsByProjectPlanned = async (projectId: string) => {
  try {
    const { data } = await Api.post(`/api/ProjectPlanned/AddAllocationsByProjectPlanned?projectId=${projectId}`);
    return data;

  } catch (error) {
    const message = 'Erro ao adicionar alocações por Projeto Planejado';
    throw new ApiException(getErrorMessage(error, message));
  }
}

export const getProjectBudgetPositionsByProjectId = async (projectId: string) : Promise<IApiResponse<ProjectBudgetPosition[]> | ApiException> => {
  try {
      const { data } = await Api.get<IApiResponse<ProjectBudgetPosition[]>>(`/api/ProjectPlanned/GetProjectBudgetPositionsByProjectId/${projectId}`)
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  } 
}


export const getProjectPlannedsByProjectId = async (projectId: string) : Promise<IApiResponse<IProjectPlannedResponse> | ApiException> => {
  try {
      const { data } = await Api.get<IApiResponse<IProjectPlannedResponse>>(`/api/ProjectPlanned/GetProjectPlannedsByProjectId/${projectId}`)
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  } 
}

export const getProjectPlannedById = async (id: string) : Promise<IApiResponse<IProjectPlanned> | ApiException> => {
  try {
      const { data } = await Api.get<IApiResponse<IProjectPlanned>>(`/api/ProjectPlanned/GetProjectPlannedById/${id}`)
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  } 
}

export const getProjectPlannedHistory = async (projectId: string, skip: number, take: number) : Promise<IApiResponse<IProjectPlannedHistoryPage> | ApiException> => {
  try {
      const { data } = await Api.get<IApiResponse<IProjectPlannedHistoryPage>>(`/api/ProjectPlannedHistory/GetProjectPlannedHistory?id=${projectId}&skip=${skip}&take=${take}`)
      return data;
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
  }
}
